(function() {
  'use strict';

  const navbar = document.querySelector('header'),
        lints = document.querySelectorAll('.sl');
  let sitelint,
      warningBarHeight,
      lastScrollTop = 0;


  function updateSitelint() {
    sitelint = document.querySelector('.js-lint');
    warningBarHeight = sitelint ? sitelint.offsetHeight : 0;

    if (sitelint) {
      window.addEventListener('load', updateTop, { once: true });
      window.addEventListener('scroll', throttleScroll);
      window.addEventListener('resize', onResize);
    } else {
      window.removeEventListener('scroll', throttleScroll);
      window.removeEventListener('resize', onResize);
      navbar.style.top = `0`;
    }
  }

  function updateTop() {
    document.documentElement.style.setProperty('--lint-top', `${warningBarHeight}px`);
  }

  function updateNavbarPosition(offset) {
    navbar.style.top = `-${offset}px`;
    document.documentElement.style.setProperty('--lint-top', `${warningBarHeight - offset}px`);
  }

  function onScroll() {
    const currentScrollTop = window.scrollY || document.documentElement.scrollTop,
          offset = Math.min(currentScrollTop, warningBarHeight);

    updateNavbarPosition(offset);
    lastScrollTop = Math.max(0, currentScrollTop);
  }

  let isScrolling = false;
  function throttleScroll() {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        onScroll();
        isScrolling = false;
      });
      isScrolling = true;
    }
  }

  function onResize() {
    updateSitelint();
    onScroll();
  }

  lints.forEach((lint) => {
    lint.querySelector('.sl__close').addEventListener('click', function() {
      if (lint.id.includes('IsExperienceEditorMode')) return;

      const now = new Date();
      now.setMonth(now.getMonth() + 1);
      document.cookie = `sitelint${lint.id}=hidden;expires=${now.toUTCString()};path=/`;
      lint.remove();

      updateSitelint();
      updateTop();
    });
  });

  updateSitelint();

})();
